import React, {useState} from 'react';
import PropTypes from 'prop-types';
import CustomSidePanel from "../common/CustomSidePanel";
import NotificationPanelItem from "./NotificationPanelItem";
import styled from "@emotion/styled";
import { setPanel } from "../../redux/actions/panelActions";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";


import {ReactComponent as ContractIcon} from "../../assets/notif-contract.svg";
import {getCreationTime} from "../../utils";
import {updateAlert} from "../../redux/actions/AlertsActions";


const ContainerWrapper = styled.div`

`;

const NotificationsWrapper = styled.div`
    //display: grid;
    //grid-auto-flow: row;
    //grid-row-gap: 8px;
    display: flex;
    flex: 1;
    flex-direction: column;
    overflow-y: scroll;
    
    align-items: center;
    
    width: fit-content;
    height: 100%;
    min-width: 374px;
    padding: 16px 16px 40px 16px;
    
    background: var(--color-gray-400);
    
    > * {
      margin-bottom: 16px;
    }
`;

const ViewAllButton = styled.div`
    position: absolute;
    width: 100%;
    height: 48px;
    bottom: 0;
    
    display: flex;
    justify-content: center;
    align-items: center;
    
    /* default/shade/white */
    background: #FFFFFF;
    box-shadow: -1px -3px 8px 2px rgba(0,0,0,0.1), 0px -3px 11px 0px rgba(0,0,0,0.06);

    color: var(--color-blue-600);
`;


function NotificationsContainer(props) {
    let history = useHistory();
    const {
        showPanel,
        alerts,
        setPanel,
        updateAlert
    } = props;

    //const [notifications, setNotifications] = useState([...alerts]);

    const handleOnDrawerClose = () => {
        setPanel({notification: false})
    };

    const handleOnNotificationClose = (alert) => {
        updateAlert({
            ...alert,
            seen: true
        })
    };

    const viewAllButtonClick = () => {
        history.push('/alerts');
        setPanel({notification: false})
    };


    return (
        <ContainerWrapper>
            <CustomSidePanel open={showPanel} onDrawerClose={handleOnDrawerClose}>

                <NotificationsWrapper>
                    {
                        alerts.map(item => {
                            return <NotificationPanelItem
                                key={item.id}
                                heading={item.heading}
                                icon={<ContractIcon/>}
                                content={item.body}
                                timeCreated={getCreationTime(item.timeCreated)}
                                onClose={() => handleOnNotificationClose(item)}
                                style={{"padding": "0 8px"}}
                            />
                        })
                    }
                </NotificationsWrapper>

                <ViewAllButton onClick={viewAllButtonClick}>
                    View All Notifications
                </ViewAllButton>
            </CustomSidePanel>
        </ContainerWrapper>
    );
}

NotificationsContainer.propTypes = {};
NotificationsContainer.defaultProps = {};


function mapStateToProps(state) {

    let alerts = state.alerts;
    // Filter out seen alerts.
    alerts = alerts.filter(item => !item.seen);

    // TODO: sort alerts by time created.
    // Only show the 10 most recent alerts.
    alerts = alerts.slice(0, 10);

    return {
        showPanel: state.panel.notifications,
        alerts
    }
}

const mapDispatchToProps = {
    setPanel,
    updateAlert,
};

export default connect(mapStateToProps, mapDispatchToProps)((NotificationsContainer));
